export const Types = {
  LOAD_MESSAGES: 'load_messages',
  LOAD_MESSAGES_SUCCESS: 'load_messages_success',
  LOAD_MESSAGES_ERROR: 'load_messages_error',
}

export function loadMessages() {
  return {
    type: Types.LOAD_MESSAGES,
  }
}

export function loadMessagesSuccess(payload) {
  return {
    type: Types.LOAD_MESSAGES_SUCCESS,
    payload,
  }
}

export function loadMessagesError(payload) {
  return {
    type: Types.LOAD_MESSAGES_ERROR,
    payload,
  }
}

function messagesReducer(state = [], action) {
  switch (action.type) {
    case Types.LOAD_MESSAGES_SUCCESS:
      return [...action.payload]
    default: return state
  }
}

export default messagesReducer
